import React from 'react';
import styled from 'styled-components';
import { RestorativeProgram } from '../../services/Restorative';
import Checkbox from '../Checkbox';

interface Props {
  programs: RestorativeProgram[];
  selected: RestorativeProgram[];
  onUpdate: (selectedPrograms: RestorativeProgram[]) => void;
}

const RadioGroup = styled.div`
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
`;

const Container = styled.div`
  margin-bottom: 1rem;
`;

const RestorativeProgramSelection: React.FC<Props> = ({ programs, selected, onUpdate }) => {
  const isSelected = (program: RestorativeProgram) => {
    for (const selectedProgram of selected) {
      if (selectedProgram.id === program.id) {
        return true;
      }
    }

    return false;
  };

  const filterOutProgram = (program: RestorativeProgram) => {
    const newSelected: RestorativeProgram[] = [];
    selected.map((selectedProgram) => {
      if (selectedProgram.id !== program.id) {
        newSelected.push(selectedProgram);
      }
    });

    return newSelected;
  };

  const handleToggle = (program: RestorativeProgram) => {
    const updatedPrograms = isSelected(program) ? filterOutProgram(program) : [...selected, program];
    onUpdate(updatedPrograms);
  };

  return (
    <Container>
      <RadioGroup>
        {programs.map((program) => {
          return (
            <Checkbox
              label={program.name}
              key={program.id}
              defaultChecked={selected.some((obj: RestorativeProgram) => obj['id'] === program.id)}
              onClick={() => handleToggle(program)}
            />
          );
        })}
      </RadioGroup>
    </Container>
  );
};

export default RestorativeProgramSelection;
